// extracted by mini-css-extract-plugin
export default {"firstTrainTitle":"Trains_firstTrainTitle__+3FBH"};